import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ac1b93c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/components/student-detail-record.css?vue&type=style&index=0&id=7ac1b93c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac1b93c",
  null
  
)

export default component.exports